import { render, staticRenderFns } from "./PAPlans.vue?vue&type=template&id=2fd6953e&"
import script from "./PAPlans.vue?vue&type=script&lang=js&"
export * from "./PAPlans.vue?vue&type=script&lang=js&"
import style0 from "./PAPlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAPlans.vue"
export default component.exports